export const COLORS = {
  primary: '#4ECDC4',
  secondary: '#45B7D1',
  accent: '#F7DC6F',
  warning: '#FF6B6B',
  success: '#4ECDC4',
};

export const LIGHT_THEME = {
  background: '#FFFFFF',
  surface: '#F8F9FA',
  card: '#FFFFFF',
  text: '#1A1A1A',
  textSecondary: '#6C757D',
  border: '#E9ECEF',
  shadow: 'rgba(0, 0, 0, 0.1)',
  ...COLORS,
};

export const DARK_THEME = {
  background: '#0B0F0E',
  surface: '#141A18',
  card: '#1E2523',
  text: '#E9F1EF',
  textSecondary: '#9AA3A8',
  border: '#1E2523',
  shadow: 'rgba(0, 0, 0, 0.3)',
  ...COLORS,
};

export const CARD_TEMPLATES = {
  classic: {
    name: 'Classic',
    background: '#FFFFFF',
    text: '#1A1A1A',
    accent: '#4ECDC4',
    border: '#E9ECEF',
  },
  modern: {
    name: 'Modern',
    background: '#141A18',
    text: '#E9F1EF',
    accent: '#CFFFEF',
    border: '#1E2523',
  },
  bold: {
    name: 'Bold',
    background: '#0B0F0E',
    text: '#FFFFFF',
    accent: '#F7DC6F',
    border: '#1E2523',
  },
  pastel: {
    name: 'Pastel',
    background: '#FFF5F7',
    text: '#2D3748',
    accent: '#FF6B6B',
    border: '#FFE4E9',
  },
  omni: {
    name: 'OMNI',
    background: '#0B0F0E',
    text: '#E9F1EF',
    accent: '#CFFFEF',
    border: '#1E2523',
  },
};
